/*
 * View for the advanced conversation area which is shown on a separate tab
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicConversation/template/topicConversationTemplate.html",
], function (Marionette, TopicConversationTemplate) {
  var TopicConversationView = {};

  TopicConversationView.topicConversationLayout = Marionette.Layout.extend({
    template: TopicConversationTemplate,
    regions: {
      diagram: "#conversationDiagram",
      response: "#conversationResponse",
      decisionChoice: "#decisionChoice",
    },
  });

  return TopicConversationView;
});
